/* Local currency on the landing page (v49).
   Shopify charges market prices it rounds itself (e.g. $26.95 -> EUR 24.95)
   and converts fixed bundle discounts at the live rate. The page used to
   convert dollars with its own rounding, so a visitor in Portugal saw one
   total on the page and another in the cart. Now every known dollar figure
   maps to the EXACT local amount Shopify will charge, read from the store
   (window.IF_LOCAL, printed by Liquid in cents). Unknown figures convert at
   the live rate with no .95 rounding. */
(function(){
var R=1,C='USD';
try{if(window.Shopify&&Shopify.currency){R=parseFloat(Shopify.currency.rate)||1;C=Shopify.currency.active||'USD';}}catch(e){}
if(R===1&&C==='USD')return;
var fmt;try{fmt=new Intl.NumberFormat(document.documentElement.lang||navigator.language||'en',{style:'currency',currency:C});}catch(e){fmt={format:function(v){return C+' '+v.toFixed(2);}};}
var DISC={1:0,2:6.95,3:18.90};
function L(){var l=window.IF_LOCAL;return(l&&l.mask>0&&(!l.cur||l.cur===C))?l:null;}
function r2(v){return Math.round(v*100)/100;}
function bundle(q){var l=L();return r2((q*l.mask-Math.round(DISC[q]*R*100))/100);}
function table(){var l=L();if(!l)return null;var t={};
t['26.95']=l.mask/100;t['44.95']=l.maskCmp/100;
t['46.95']=bundle(2);t['61.95']=bundle(3);
t['89.90']=r2(2*l.maskCmp/100);t['134.85']=r2(3*l.maskCmp/100);
t['23.48']=r2(bundle(2)/2);t['20.65']=r2(bundle(3)/3);
if(l.goggles)t['22.95']=l.goggles/100;if(l.gogglesCmp)t['39.95']=l.gogglesCmp/100;
if(l.gloves)t['14.95']=l.gloves/100;if(l.mystery)t['26.95b']=l.mystery/100;
if(l.protect)t['2.99']=l.protect/100;
return t;}
function convert(usd){var t=table();var k=usd.toFixed(2);if(t&&t[k]!==undefined)return t[k];return r2(usd*R);}
window.IF_CONV=convert;window.IF_FMT=fmt;window.IF_BUNDLE_LOCAL=function(q){return L()?bundle(q):null;};
var MONEY=/\$\s?(\d+(?:[.,]\d{2})?)/g;
function walk(root){
var nodes=root.querySelectorAll('span,div,strong,b,p,button,td,li');
for(var i=0;i<nodes.length;i++){
var n=nodes[i];
if(n.children.length)continue;
if(n.getAttribute&&n.getAttribute('data-if-cur'))continue;
var t=n.textContent;
if(!t||t.indexOf('$')<0)continue;
var changed=t.replace(MONEY,function(m,num){var v=parseFloat(String(num).replace(',','.'));if(isNaN(v))return m;return fmt.format(convert(v));});
if(changed!==t){n.textContent=changed;n.setAttribute('data-if-cur','1');}
}}
function run(){var root=document.getElementById('if');if(root)walk(root);var s=document.getElementById('if-sticky');if(s)walk(s);}
function loop(){var root=document.getElementById('if');if(root){var nodes=root.querySelectorAll('span,div,strong,b,p,button');for(var i=0;i<nodes.length;i++){var n=nodes[i];if(n.children.length)continue;if((n.textContent||'').indexOf('$')>-1)n.removeAttribute('data-if-cur');}}run();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
setInterval(loop,500);
})();
